import {useRef, useEffect} from 'react';
import {ReactComponent as Date} from 'assets/icons/date.svg';
import {useIntl} from 'react-intl';

const DateField = ({settings, onChange, ...rest}) => {
  const dateField = useRef(null);
  const intl = useIntl();
  const {
    name,
    label,
    placeholder,
    state,
    wrapperClasses = '',
    required = false,
    disabled = false,
    error,
  } = settings || {};

  useEffect(() => {
    if (dateField?.current) {
      // eslint-disable-next-line no-undef
      Drupal.attachBehaviors(dateField.current);
    }
  }, []);

  if (!name) {
    return '';
  }

  const renderLabel = () => {
    if (!label) {
      return '';
    }

    return (
      <label className={`${required ? ' form-required' : ''}`} htmlFor={name}>{intl.formatMessage({id: label})}</label>
    );
  };

  return (
    <div ref={dateField} className={`${wrapperClasses} ${error ? 'form-item--error' : ''}`}>
      {renderLabel()}
      <div className="input--date">
        <input name={name}
               className="form-date"
               type="date"
               placeholder={placeholder}
               onChange={onChange}
               required={required}
               disabled={disabled}
               value={state && state.hasOwnProperty(name) ? state[name] : ''}
               {...rest}/>
        <Date />
        {error &&
          <span className="form-item__error">
            {intl.formatMessage({id: error})}
          </span>
        }
      </div>
    </div>
  )
};

export default DateField;
